<div class="ready-indicator">
  <div class="status-icon">✓</div>
  <h2>Secure Wallet Ready</h2>
  <p>embarkAI is ready for secure operations</p>
  <div class="info">
    <div class="info-row">
      <strong>Origin:</strong>
      <span>{{origin}}</span>
    </div>
    <div class="info-row">
      <strong>Status:</strong>
      <span class="status-active">Active</span>
    </div>
    <div class="info-row">
      <strong>Version:</strong>
      <span>{{iframeVersion}}</span>
    </div>
    <div class="info-row">
      <strong>Documentation:</strong>
      <a
        href="https://docs.embarkai.io"
        target="_blank"
        rel="noopener noreferrer"
        style="color: #667eea; text-decoration: none"
        >docs.embarkai.io</a
      >
    </div>
  </div>
</div>
